import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  showToolsSlide(index: number) {
    //TODO: This function should control the carousel
    // of the Improving Factor Diversification section.
  }

  showResourcesSlide(index: number) {
    //TODO: This function should control the carousel
    // of the Sharing Knowledge section.
  }
}
